import React from "react";
import Card from "components/card";
import Button from "components/button";
import { LucideAward } from "lucide-react";
import { formatDateRange } from "utils";


const CertificateCard = ({
  recordData,
}) => 
  {
  
  return (

    <Card className="text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-emerald-200 bg-gradient-to-br from-emerald-50 to-white dark:from-emerald-900 dark:to-white/10 dark:border-emerald-900">
      <div className="pb-6 p-4">
        <div className="flex items-start gap-3">
            <div className="p-2 rounded-full bg-emerald-100 ">
                <LucideAward className="w-5 h-5 text-emerald-600"/>
            </div>
            <div className="flex-1">
              <h4 className="font-semibold text-sm dark:text-white">
                {recordData?.class_title}
              </h4>
              <p className="text-xs text-slate-700 mt-1 dark:text-slate-200">
                Issued: {recordData?.issued_month_year}
              </p>
              <p className="text-xs text-slate-700 mt-1 dark:text-slate-200">
                Expires: {recordData?.expires_month_year}
              </p>
              <Button
                className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all shrink-0 outline-none border bg-white text-slate-900 hover:bg-white hover:text-slate-900 h-8 rounded-lg gap-1.5 px-3 w-full mt-3 text-xs hover:shadow-none dark:bg-white/10 dark:text-white"
              >
                Download Certificate
              </Button>
            </div>
        </div>
        

      </div>


    </Card>
  );
};

export default CertificateCard;
